/* eslint-disable react/jsx-no-bind */

// Libraries
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

// Custom Components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import ViewEditActions from "components/DetailList/ViewEditActions";

// Pages
import Information from "pages/content/otherFacilities/new-facility/components/Information";

const FacilityDetail = ({
  formData,
  detailPage = true,
  setDetailPage = () => {},
  handleEdit,
  handleLocationChange = () => {},
  locationObj = {},
  selectedLocation = {},
  selectedFile = "",
}) => {
  const { submitForm, resetForm } = useFormikContext();

  const handleCardTitle = () => "Other facility Info";

  return (
    <MDBox>
      <MDBox lineHeight={0} style={{ display: "flex", justifyContent: "space-between" }}>
        <MDTypography variant="h5" fontWeight="bold" textTransform="capitalize" mb={1}>
          {handleCardTitle()}
        </MDTypography>
        <ViewEditActions
          detailPage={detailPage}
          handleEdit={handleEdit}
          handleClose={() => {
            resetForm();
            setDetailPage(true);
          }}
          handleSave={() => {
            submitForm();
          }}
        />
      </MDBox>
      <MDBox>
        <Information
          formData={formData}
          editPage
          detailPage={detailPage}
          locationObj={locationObj}
          handleLocationChange={handleLocationChange}
          selectedLocation={selectedLocation}
          selectedFile={selectedFile}
        />
      </MDBox>
    </MDBox>
  );
};

// typechecking props for FacilityDetail
FacilityDetail.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.func]).isRequired,
  detailPage: PropTypes.bool,
  setDetailPage: PropTypes.func,
  handleEdit: PropTypes.func.isRequired,
  handleLocationChange: PropTypes.func,
  selectedLocation: PropTypes.instanceOf(Object),
  selectedFile: PropTypes.string,
  locationObj: PropTypes.instanceOf(Object),
};

export default FacilityDetail;
